// extracted by mini-css-extract-plugin
module.exports = {"defaultLogo":"InstitutionLogo_defaultLogo__1ndI3","logo":"InstitutionLogo_logo__3rfFM"};